import { ApolloClient, gql, useQuery } from "@apollo/client";
import { useAuth } from "@hooks";

export const DISCOUNT_CODE = gql`
query DiscountCode($discountSource: String!) {
  discountCode(discountSource: $discountSource) {
    code
    discountSource
    userId
  }
}
`;

interface QueryResult {
  discountCode: {
    code: string;
    discountSource: string;
    userId: string;
  };
}

interface HookReturn {
  discountCode: {
    code: string;
    discountSource: string;
    userId: string;
  };
  loading: boolean;
}

export const useDiscountCode = (discountSource: string): HookReturn => {
  const { data, loading } = useQuery<QueryResult>(DISCOUNT_CODE, {
    variables: { discountSource },
  });
  return {
    discountCode: data?.discountCode ?? {
      code: "",
      discountSource: "",
      userId: "",
    },
    loading,
  };
}


